import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/App';
import { config } from '@/app/config/env';

// Inter is the design file's type family. Self-hosted (rather than loaded from
// Google Fonts) so the app renders identically offline, adds no third-party
// request on first paint, and needs no font-src exception in the CSP.
import '@fontsource-variable/inter';

import '@/styles/globals.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element #root not found in index.html.');
}

// Reflects the configured application name in the tab title.
document.title = config.appName;

createRoot(container).render(
  // StrictMode surfaces unsafe lifecycles and missing effect cleanup during
  // development by double-invoking effects. It is stripped from production.
  <StrictMode>
    <App />
  </StrictMode>,
);
